import * as React from 'react';
import { Card, LineItemBundleRow } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { Toggletip } from '../../../Toggletip/Toggletip.js';

const CardGlassesConfiguration = ({ bundleChildLineItems , disclaimer , disclaimerTooltip  })=>{
    const intl = useIntl();
    return /*#__PURE__*/ React.createElement(Card.Section, {
        className: "card-glasses-configuration"
    }, bundleChildLineItems === null || bundleChildLineItems === void 0 ? void 0 : bundleChildLineItems.map((item, i)=>/*#__PURE__*/ React.createElement(LineItemBundleRow, {
            key: `${item.body}-${i}`,
            title: item.title,
            body: item.body,
            currency: intl.currency,
            price: item.price,
            originalPrice: item.originalPrice,
            priceIsZeroLabel: intl.getLabel('cart.lineItem.glasses.isIncluded', {
                hideLabelKey: true
            }),
            action: item.action
        })
    ), /*#__PURE__*/ React.createElement("div", {
        className: "card-glasses-configuration__footer"
    }, disclaimer ? /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        spacings: [
            'mb-0'
        ]
    }, disclaimer) : null, disclaimerTooltip ? /*#__PURE__*/ React.createElement(Toggletip, {
        message: disclaimerTooltip
    }) : null));
};

export { CardGlassesConfiguration };
//# sourceMappingURL=CardGlassesConfiguration.js.map
